// tslint:disable:no-commented-code
// tslint:disable:no-duplicate-string
// tslint:disable:only-arrow-functions
// tslint:disable:no-big-function

import { recommendationsPanelsLocaleKeys } from '@epicuro-next/constants/features/localization';
import { DynamicBasketNotificationElement } from '@epicuro-next/models/basket';
import { PaneLocation } from '@epicuro-next/state/user-ui-state';

import { clearPaneContent } from '../../events';

export function createDynamicBasketNotification(options: {
  withClearPaneOnNavigatingToBasketEvent: boolean;
  paneLocation: PaneLocation;
}): DynamicBasketNotificationElement {
  const element: DynamicBasketNotificationElement = {
    contentTypeId: 'epc-basket-notification',
    styles: {
      variables: {
        '--basket-notification-bg': 'var(--dark-mode-primary-alpha, #efefef)',
        '--btn-view-basket-border-color': '#cccccc',
        '--btn-primary-color': '#000000',
        '--basket-notification-title-color': 'var(--white, #000)',
        '--basket-notification-title-font-size': '1.2rem',
        '--color-brand-white': 'var(--dark-mode-gray-700, #ffffff)',
      },
      css: `.basket-notification-in-panel .product-title {font-weight: bold;}
        .basket-notification-in-panel .product-title span {font-weight: normal;}
        .basket-notification-in-panel .btn {
          color: var(--basket-notification-title-color); 
          border: 1px solid var(--dark-mode-primary-alpha, #cccccc) !important; 
        }`,
    },
    data: {
      basketId: {
        provider: 'GlobalStoreProviderService',
        property: {
          path: 'basket.data.activeBasketId',
          once: true,
        },
      },
      basketNotification: {
        provider: 'GlobalStoreProviderService',
        property: {
          path: 'basket.data.basketNotification',
          once: true,
        },
      },
    },
    inputs: {
      additionalCssClasses: 'basket-notification-in-panel',
      additionalViewBasketButtonClasses: 'bg-white m-2',
      options: {
        hideCloseButton: true,
        hideRecommendationPanel: true,
        hideProductImage: true,
        hideNumbers: true,
        hideProductId: true,
        hideAddedToBasketMessage: false,
      },
      notification: {
        provider: 'self',
        property: 'basketNotification',
      },
      basketButtonText: recommendationsPanelsLocaleKeys.goToBasket,
      showNavigateToBasketButton: {
        provider: 'GlobalStoreProviderService',
        property: {
          paths: ['router.state.url', 'basket.data.activeBasketId'],
          once: true,
        },
        transform: function ([routerStateUrl, activeBasketId]: [
          string,
          string,
        ]): boolean {
          return !routerStateUrl.includes(`/basket/${activeBasketId}`);
        }.toString(),
      },
      basketLink: {
        provider: 'self',
        property: 'basketId',
        transform: function (basketId: string): string[] {
          return ['/basket', basketId];
        }.toString(),
      },
    },
    outputs: {
      navigatingToBasket: options.withClearPaneOnNavigatingToBasketEvent
        ? [clearPaneContent(options.paneLocation)]
        : undefined,
    },
  };

  return element;
}
